import {take, put} from 'redux-saga/effects';
import {ROUTE_UNMOUNT_SIDE_EFFECT_COMPLETED} from '@computerrock/formation-router';
import {efServiceAssignmentTypes} from '@ace-de/eua-entity-types';
import updateServiceAssignment from '../../service-assignments/sagas/updateServiceAssignment';
import * as satrActionTypes from '../satrActionTypes';

/**
 * Update SATR requirements flow
 */
const updateSATRRequirementsFlow = function* updateSATRRequirementsFlow() {
    while (true) {
        const {payload} = yield take(satrActionTypes.SUBMIT_SATR_REQUIREMENTS_FORM);
        const {serviceAssignmentLineNo, serviceAssignmentData, serviceCaseId} = payload;

        yield* updateServiceAssignment({
            caller: satrActionTypes.SUBMIT_SATR_REQUIREMENTS_FORM,
            assignmentType: efServiceAssignmentTypes.TRAILER_RETURN,
            serviceAssignmentLineNo,
            serviceCaseId,
            serviceAssignmentData,
        });

        yield put({
            type: ROUTE_UNMOUNT_SIDE_EFFECT_COMPLETED,
            payload: {caller: satrActionTypes.SUBMIT_SATR_REQUIREMENTS_FORM},
        });
    }
};

export default updateSATRRequirementsFlow;
